define('app/models/sePlayMdl',[

  'app.env',

  'lodash',
  'backboneMdl',

  'app/config/constants',

  'app/helper/play.language',

  'app/models/sePlayIndexMdl',
  'app/models/sePlayPageMdl',

  'app/services/sePlayApiSrv',

  'app/helper/logging.se'

], function (
  ENV,
  _,
  BackboneBase,
  CONSTANTS,
  language,
  sePlayIndexMdl,
  sePlayPageMdl,
  sePlayApiSrv,
  seLogging
) {

  var LOG_LABEL = 'PLAY MDL'

  var STATUS = CONSTANTS.STATUS

  /**
   */

  var
    PlayModel = BackboneBase.Model.extend({
      // basics
      index: null, // PlayIndexMdl
      page: null, // PlayPageMdl

      defaults: {
        cid: null,
        id: null, // PLAYSID from current URI

        form: null,
        header: null,

        baseUri: null,      // set in base template from backend
        pageNr: null,       // set in base template from backend
        fieldPrefix: null   // set in base template from backend
      },
      isParsing: false,
      isTemporary: false,

      init: function (params) {
        var _this = this

        _this.index = new sePlayIndexMdl(null, {
          language: language
        })
        _this.page = new sePlayPageMdl(null, {
          language: language
        })

        _this.index.on('change:settings', function (_index, newSettings) {

          if (!newSettings) return

          _this.set('title', newSettings.Description)

          _this.index.translate(language)

        })

        _this.saveBaseVals()

        _this.fetch()

      },

      // sync
      sync: function (method, model, options) {

        var _this = this

        var succCb0 = options.success || function () {},
          errCb0 = options.error || function () {}

        switch (method) {
          case 'read': // .fetch

            _this.trigger('isLoading')

            _this.index.clear()
            _this.page.clear()

            sePlayApiSrv.getIndex(
              function succCb (indexJsml) {

                _this.index.parse(indexJsml)
                _this.index.trigger('hasLoaded')

                sePlayApiSrv.getPage(
                  function succCb (playPageObj) {

                    if (typeof options.beforeSuccess === 'function') {
                      options.beforeSuccess()
                    }

                    succCb0.apply(this, [playPageObj, options]) // this goes through parse

                    _this.trigger('hasLoaded')

                  },
                  function errCb (status, err) {
                    // 500: error

                    switch (status) {
                      case 500:
                        _this.set('error', { data: err, status: status })

                        _this.trigger('hasFailed')
                        _this.page.trigger('hasFailed')
                        break
                    }
                    errCb0.apply(this, arguments)
                  }
                )

              },
              function errCb (status, err) {
                // 500: error

                switch (status) {
                  case 500:
                    _this.set('error', { data: err, status: status })

                    _this.trigger('hasFailed')
                    _this.index.trigger('hasFailed')
                    _this.page.trigger('hasFailed')
                    break
                }
                errCb0.apply(this, arguments)
              }
            )

            break
          case 'update': // .save

            if (_this.status < STATUS.LOADED)
              return

            _this.trigger('isSaving')

            var formDataObj = _this.get('form')

            _this.trigger('isSaving')

            return sePlayApiSrv.sendForm(
              formDataObj,
              function succCb (playPageObj) {

                if (typeof options.beforeSuccess === 'function') {
                  options.beforeSuccess()
                }

                succCb0.apply(this, [playPageObj, options]) // this goes through parse

                if (playPageObj.status.forcedRedirect) {
                  _this.setStatus(STATUS.DESTROYED)
                } else {
                  _this.trigger('hasSaved')
                }

              },
              function errCb (status, data, err) {
                switch (status) {
                  case 504:
                    // timeout -> retry may be in action
                    if (err.details.res.status === 'timeout') {
                      // failed but recoverable by user
                      _this.trigger('hasSaved')

                    } else if (err.details.res.status === 'retry') {
                      // dont fail yet.
                      return
                    }
                    break
                  case 0:
                  case 404:
                  case 500:
                    //console.error(LOG_LABEL, "Failed to save page", [status, err]);
                    _this.set('error', { data: data || err.message, status: status, err: err })

                    _this.trigger('hasFailed')
                    _this.page.trigger('hasFailed')
                    break
                }

                //_this.trigger('hasFailed');

                errCb0.apply(this, [{ status: status, error: err, data: data }])
              }
            )

            break
        }
      },

      // read in
      parse: function (playPageObj) {
        var _this = this

        if (!playPageObj) {
          console.warn(LOG_LABEL, 'missing play page object', playPageObj)
          return
        }

        // TODO: remove hardcoding of XML structure for layout, progress and page elements
        var pageJsml = playPageObj.jsml,
          statusObj = playPageObj.status

        _this.page.trigger('isLoading')

        _this.page.elements.reset()

        _this.cset('header', statusObj)

        if (!pageJsml) {
          console.warn(LOG_LABEL, 'tried to parse non-play-page jsml', playPageObj)
        } else {
          _this.page.parse(pageJsml, {playMode: true})

          // set SE_LOGGING_INFO
          seLogging.setInfo({
            play_page_id: pageJsml[1].page_id,
            play_session: ENV.play_sid
          })

        }

        _this.page.trigger('hasLoaded')

      },

      // custom destroy

      // write out

      // actions

      saveUriInfo: function () {
        var _this = this

        var searchStr = location.search.replace(/^\??/, ''),
          params = searchStr.split('&').reduce(function (r, val) {
            var tmp = val.split('=')
            r[tmp[0]] = decodeURIComponent(tmp[1])
            return r
          }, {}),
          pageNr = params.page_number !== undefined ? +params.page_number : 1,
          newSearchStr,
          baseUrl

        delete (params.page_number)
        delete (params.s)

        params = {}
        params.PLAYSID = ENV.play_sid

        newSearchStr = '?' + _.map(params, function (val, key) {
          return key + '=' + encodeURIComponent(val)
        }).join('&')

        baseUrl = ENV.play_api_url + newSearchStr

        _this.set('pageNr', pageNr)
        _this.set('baseUri', baseUrl)

        return baseUrl
      },

      saveBaseVals: function () {
        var _this = this

        _this.saveUriInfo()

        // more base vals are read-in via the playApiSrv (header / compiled etc.)

      },

      getPage: function (succCb, errCb) {
        var _this = this

        _this.fetch({
          success: succCb,
          error: errCb
        })

      },

      sendForm: function (formData, beforeSuccCb, succCb, errCb) {
        var _this = this

        _this.cset('form', formData)

        _this.save(null, {
          beforeSuccess: beforeSuccCb,
          success: succCb,
          error: errCb
        })

      },

      goBack: function (succCb, errCb) {
        var _this = this

        _this.trigger('isSaving')

        sePlayApiSrv.goBack(
          function succ (prevPageXml) {
            _this.trigger('hasSaved')

            _this.parse(prevPageXml)

            succCb.apply(this, arguments)
          },
          function err (status, err) {
            _this.trigger('hasFailed')
            _this.set('error', { data: err, status: status })
            errCb.apply(this, arguments)
          }
        )
      }
    })

  return PlayModel

})
;
